var React = require('react');

function IconPinFilled (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.75251 8.83625C10.165 11.1469 9.94001 12.8369 8.79439 13.8556L8.41314 14.1944L8.05251 13.835L6.54626 12.3213C5.84584 11.6171 5.1448 10.9136 4.44314 10.2106C2.21814 8.00938 1.02564 6.8275 0.853763 6.65375L0.497513 6.29375L0.833138 5.91438C1.85751 4.755 3.57251 4.4825 5.79814 4.87313L9.28939 0.128128L9.73501 0.580003L11.8963 2.77188L14.4794 5.335L9.75251 8.83625Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M0.868758 14.5456L0.101883 13.7812L4.06251 9.80687L4.82938 10.5712L0.868758 14.5456Z","fill":"currentColor","key":1})]);
}

IconPinFilled.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = IconPinFilled;

IconPinFilled.default = IconPinFilled;
